import { getCookie } from '@amp/web-app-components/src/utils/cookie';
import { writable } from 'svelte/store';

export enum NowPlayingView {
    Artwork = 'artwork',
    Info = 'info',
    Queue = 'queue',
}

export const LAST_NOW_PLAYING_VIEW_LOCALSTORAGE_KEY =
    'music-classical-app-pref:last-now-playing-view-';
export const DEFAULT_NOW_PLAYING_VIEW = NowPlayingView.Artwork;

interface FullScreenPlayerState {
    isVisible: boolean;
    nowPlayingView: NowPlayingView;
}

function buildLastNowPlayingViewKey() {
    const mut = getCookie('media-user-token');
    return mut && `${LAST_NOW_PLAYING_VIEW_LOCALSTORAGE_KEY}${mut}`;
}

function initialState(
    lastNowPlayingViewKey: string | undefined,
): FullScreenPlayerState {
    let nowPlayingView: NowPlayingView;

    if (lastNowPlayingViewKey) {
        nowPlayingView =
            (window.localStorage.getItem(lastNowPlayingViewKey) as
                | NowPlayingView
                | undefined) ?? DEFAULT_NOW_PLAYING_VIEW;
    } else {
        nowPlayingView = DEFAULT_NOW_PLAYING_VIEW;
    }

    return {
        isVisible: false,
        nowPlayingView,
    };
}

export function createStore() {
    let lastNowPlayingViewKey = buildLastNowPlayingViewKey();
    const { subscribe, update } = writable(initialState(lastNowPlayingViewKey));

    return {
        subscribe,
        setVisibility: (isVisible: boolean) => {
            update((prev: FullScreenPlayerState) => ({ ...prev, isVisible }));
        },
        setNowPlayingView: (nowPlayingView: NowPlayingView) => {
            if (lastNowPlayingViewKey && typeof window !== 'undefined') {
                window.localStorage.setItem(
                    lastNowPlayingViewKey,
                    nowPlayingView,
                );
            }

            update((prev: FullScreenPlayerState) => ({
                ...prev,
                nowPlayingView,
            }));
        },
        reset: () => {
            update(() => {
                lastNowPlayingViewKey = buildLastNowPlayingViewKey();

                return initialState(lastNowPlayingViewKey);
            });
        },
    };
}

export const fullScreenPlayerState = createStore();
export type FullScreenPlayerStateStore = typeof fullScreenPlayerState;
